import { productDefinitions } from "../containers/Gfn/productDefinitions";

export const getLocale = () => {
  if (location.host.includes(".cn")) {
    return "zh-cn";
  }
  return location.pathname.slice(1, 6);
};

export const deleteCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=${COOKIE_DOMAIN}; path=/`;
};

export const isUserEnrolled = (pref, parsedConsent = {}) => {
  try {
    const consents = {};
    parsedConsent.gaming.consentGranted.forEach((consent) => {
      const [consentType, value] = consent.split(":");
      consents[consentType] = value === "true";
    });
    if (pref?.gaming?.subscribed && consents.trackBehavioralData) {
      return true;
    } else {
      return false;
    }
  } catch (err) {
    return false;
  }
};

export const isUltimateUser = (productId) => {
  return !!(
    productDefinitions[productId]?.productGroup === "RTX3080" ||
    productDefinitions[productId]?.productGroup === "RTX3080_FOUNDERS"
  );
};

export const isFreeUser = (productId) => {
  return !!(productDefinitions[productId]?.productGroup === "FREE");
};

export const isPriorityUser = (productId) => {
  return !!(
    productDefinitions[productId]?.productGroup === "PRIORITY" ||
    productDefinitions[productId]?.productGroup === "PRIORITY_FOUNDERS"
  );
};

export const isFoundersUser = (productId) => {
  return !!(
    productDefinitions[productId]?.productGroup === "PRIORITY_FOUNDERS" ||
    productDefinitions[productId]?.productGroup === "RTX3080_FOUNDERS"
  );
};

export const isPromoUser = (productId) => {
  return !!(productDefinitions[productId]?.giftCardAndPromo === true);
};

export const isPreOrderUser = (productId) => {
  return !!(productDefinitions[productId]?.preOrder === true);
};

export const isPriorityFoundersUser = (productId) => {
  // returns true for PRIORITY_FOUNDERS that are not promo => 2000, 3000, 4000, 6000
  return (
    isPriorityUser(productId) &&
    isFoundersUser(productId) &&
    !isPromoUser(productId)
  );
};

export const isPriorityPromoUser = (productId) => {
  // returns true for PRIORITY that are not FOUNDERS and are promo => 5000, 5001
  return (
    isPriorityUser(productId) &&
    !isFoundersUser(productId) &&
    isPromoUser(productId)
  );
};

export const isPriorityFoundersPromoUser = (productId) => {
  // returns true for PRIORITY_FOUNDERS that are promo => 5002, 5003
  return (
    isPriorityUser(productId) &&
    isFoundersUser(productId) &&
    isPromoUser(productId)
  );
};

export const isPriorityOnlyUser = (productId) => {
  // returns true for PRIORITY that are not FOUNDERS and are not promo => 7000, 8000, 9000
  return (
    isPriorityUser(productId) &&
    !isFoundersUser(productId) &&
    !isPromoUser(productId)
  );
};

export const isUltimateFoundersUser = (productId) => {
  // returns true for RTX3080_FOUNDERS that are FOUNDERS and not promo => 10000, 10001, 10002
  return (
    isUltimateUser(productId) &&
    isFoundersUser(productId) &&
    !isPromoUser(productId)
  );
};

export const isUltimateOnlyUser = (productId) => {
  // returns true for RTX3080 that are not FOUNDERS and are not promo => 11000, 11001, 11002
  return (
    isUltimateUser(productId) &&
    !isFoundersUser(productId) &&
    !isPromoUser(productId)
  );
};

export const isUltimatePromoUser = (productId) => {
  // returns true for RTX3080 that are not FOUNDERS and are promo => 13001, 13002
  return (
    isUltimateUser(productId) &&
    !isFoundersUser(productId) &&
    isPromoUser(productId)
  );
};

export const isUltimateFoundersPromoUser = (productId) => {
  // returns true for RTX3080 that are FOUNDERS and are promo => 13003, 13004
  return (
    isUltimateUser(productId) &&
    isFoundersUser(productId) &&
    isPromoUser(productId)
  );
};

export const getVoltronBase = () => {
  if (isCNTLD()) {
    return VOLTRON_BASE_CN;
  }
  return VOLTRON_BASE;
};

export const isCNTLD = () => {
  return location.host.includes(".cn");
};

export const isCOMTLD = () => {
  return location.host.includes(".com");
};
